import React from 'react';
import LevelingRankPicker from "../levelingRankPicker/LevelingRankPicker";
import './AnniversaryTier2SetsRankPicker.sass'

export default class Leveling1to300 extends React.PureComponent {
    static minValue = 0;
    static maxValue = 13;

    static describeRank = rank => rank.toString();
    static getDefaultValue = () => [0, 1];

    static marks = {
        0: '0',
        1: '1',
        2: (
            <span>
    2
    <span className="rc-slider-anniversary-mark-tooltip">33% OFF</span>
  </span>
        ),
        3: (
            <span>
    3
    <span className="rc-slider-anniversary-mark-tooltip">66% OFF</span>
  </span>
        ),
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12',
        13: '13',
    };

    render() {
        const { ...rest } = this.props;

        return (
            <LevelingRankPicker
                {...rest}
                min={Leveling1to300.minValue}
                max={Leveling1to300.maxValue}
                marks={Leveling1to300.marks}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/AnniversaryTier2SetsRankPicker/AnniversaryTier2SetsRankPicker.js